import BaseExecutor from './base-executor';
import MaxPlayersFromOneTeamValidator from 'services/validations/validators/lineup/max-players-from-one-team-validator';
import MaxHittersFromOneTeamValidator from 'services/validations/validators/lineup/max-hitters-from-one-team-validator';
import MinTeamsValidator from 'services/validations/validators/lineup/min-teams-validator';
import MinGamesValidator from 'services/validations/validators/lineup/min-games-validator';

export default class BaseLineupValidatorBuilder extends BaseExecutor {
    getMaxPlayersFromOneTeamValidator(sportConfig, lineupPlayers) {
        const validator = new MaxPlayersFromOneTeamValidator();
        validator.setDependencies({sportConfig, lineupPlayers});

        return validator;
    }

    getMaxHittersFromOneTeamValidator(sportConfig, lineupPlayers) {
        const validator = new MaxHittersFromOneTeamValidator();
        validator.setDependencies({sportConfig, lineupPlayers});

        return validator;
    }

    getMinTeamsValidator(sportConfig, lineupPlayers) {
        const validator = new MinTeamsValidator();
        validator.setDependencies({sportConfig, lineupPlayers});

        return validator;
    }

    getMinGamesValidator(sportConfig, lineupPlayers) {
        const validator = new MinGamesValidator();
        validator.setDependencies({sportConfig, lineupPlayers});

        return validator;
    }
}
